import { render, staticRenderFns } from "./Batchrenewal.vue?vue&type=template&id=e9f53b96&scoped=true&"
import script from "./Batchrenewal.vue?vue&type=script&lang=js&"
export * from "./Batchrenewal.vue?vue&type=script&lang=js&"
import style0 from "./Batchrenewal.vue?vue&type=style&index=0&id=e9f53b96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f53b96",
  null
  
)

export default component.exports